import { IRESTErrorSAP } from "../types/IRESTErrorSAP";

export abstract class RESTError extends Error {
  constructor(readonly originError: IRESTErrorSAP) {
    super();
  }
}
